export const APPLICATION_INSIGHT_CONNECTION_STRING = process.env.REACT_APP_APPLICATION_INSIGHT_CONNECTION_STRING
export const AUTHENTICATE_API_BASE_URL = process.env.REACT_APP_AUTHENTICATE_API_BASE_URL || ''
export const RECAPTCHA_CLIENT_KEY = process.env.REACT_APP_RECAPTCHA_CLIENT_KEY || ''
export const BROWSER_ROUTER_BASENAME = process.env.REACT_APP_BROWSER_ROUTER_BASENAME
export const MIDDLEWARE_GRAPHQL_URL =
  process.env.REACT_APP_MIDDLEWARE_GRAPHQL_URL || 'https://devdevelopers.mdvip.com/graphql'
export const ASSETS_URL = process.env.REACT_APP_ASSETS_URL || ''
